import { render } from "./StaticAndFinanceBlock.vue?vue&type=template&id=5254f7d4&scoped=true"
import script from "./StaticAndFinanceBlock.vue?vue&type=script&lang=js"
export * from "./StaticAndFinanceBlock.vue?vue&type=script&lang=js"

import "./StaticAndFinanceBlock.vue?vue&type=style&index=0&id=5254f7d4&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5254f7d4"]])

export default __exports__